

import  { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from "@angular/router";
import { Observable } from "rxjs";

import { JwtHelperService } from "@auth0/angular-jwt";
import { MainService } from './../../../Services/service.service';
import { getAuthToken } from 'src/app/api/AuthHeaders';

@Injectable({
  providedIn: "root"
})
export class MobileAuthGuard implements CanActivate {
  constructor(private route: Router, private jwtHelper: JwtHelperService, private services: MainService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise<boolean>((rs, rj) => {
      var token = getAuthToken();

      if (token && !this.jwtHelper.isTokenExpired(token)) {
        console.log("g-true");
        return rs(true);
      }
      
      this.route.navigate(['/login']);
      
      console.log("g-false");
      return rs(false);
    });
  }
}
